export const TermsOfServicePage = () => {
  return (
    <div className="mx-auto max-w-5xl space-y-10 px-6 pb-20 pt-16 md:px-10">

      {/* HEADER */}
      <section>
        <p className="text-sm uppercase tracking-[0.2em] text-[#6FE3C1]">
          Legal
        </p>

        <h1 className="mt-4 text-4xl font-bold md:text-5xl">
          Terms of Service
        </h1>

        <p className="mt-5 text-[#D9E1E8]/80">
          These Terms of Service govern the use of The AI Matters platform
          and its associated services, including JobScore Matters. By
          accessing or using our platform, you agree to comply with these
          terms.
        </p>
      </section>


      {/* PLATFORM USAGE */}
      <section>
        <h2 className="text-2xl font-semibold mb-3">
          Platform Usage
        </h2>

        <p className="text-[#D9E1E8]/80">
          The AI Matters platform is designed to support hiring operations
          for organizations, recruiters, and vendor partners. Users must
          use the platform responsibly and only for legitimate hiring and
          recruitment purposes.
        </p>
      </section>


      {/* USER RESPONSIBILITIES */}
      <section>
        <h2 className="text-2xl font-semibold mb-3">
          User Responsibilities
        </h2>

        <p className="text-[#D9E1E8]/80">
          Users are responsible for maintaining the confidentiality of
          their account information and ensuring that all submitted
          information is accurate and lawful.
        </p>

        <p className="mt-4 text-[#D9E1E8]/80">
          Any misuse of the platform, including fraudulent activity,
          unauthorized data sharing, or attempts to disrupt platform
          functionality, may result in account suspension or termination.
        </p>
      </section>


      {/* DATA USAGE */}
      <section>
        <h2 className="text-2xl font-semibold mb-3">
          Data & Information Usage
        </h2>

        <p className="text-[#D9E1E8]/80">
          Data submitted to The AI Matters platform may be processed to
          enable hiring workflows, candidate evaluation, and recruiter
          collaboration. All data usage follows our Privacy Policy and
          applicable data protection standards.
        </p>
      </section>


      {/* LIMITATION OF LIABILITY */}
      <section>
        <h2 className="text-2xl font-semibold mb-3">
          Limitation of Liability
        </h2>

        <p className="text-[#D9E1E8]/80">
          The AI Matters provides its platform on an “as available” basis.
          While we strive to ensure reliability and accuracy, we are not
          responsible for hiring decisions, third-party actions, or
          outcomes resulting from platform usage.
        </p>
      </section>


      {/* MODIFICATIONS */}
      <section>
        <h2 className="text-2xl font-semibold mb-3">
          Updates to These Terms
        </h2>

        <p className="text-[#D9E1E8]/80">
          The AI Matters may update these Terms of Service from time to
          time to reflect changes in our services or legal requirements.
          Continued use of the platform constitutes acceptance of any
          updated terms.
        </p>
      </section>


      {/* CONTACT */}
      <section>
        <h2 className="text-2xl font-semibold mb-3">
          Contact Information
        </h2>

        <p className="text-[#D9E1E8]/80">
          If you have questions regarding these Terms of Service, please
          contact us through the official contact page of The AI Matters.
        </p>
      </section>

    </div>
  );
};